import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { GetBrowser } from './browserName'

export const fetchDeviceData = async () => {

    let fingerPrintId = null
    let browserName = null
    let ipAddress = null

    // 1. Get Fingerprint ID
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    fingerPrintId = result.visitorId

    // 2. Get Browser Name
    const tempBrowserName = await GetBrowser()
    browserName = tempBrowserName;

    let ipResponse = ""
    let ipData = ""
    try {
        // 3. Get IP Address
        ipResponse = await fetch("https://ipinfo.io/json");
        ipData = await ipResponse.json();
    }
    catch(err){
        console.log("Error in fetching IP 3:", err)
        // 4. Get IP Address
        ipResponse = await fetch("https://api.ipify.org?format=json");
        ipData = await ipResponse.json();
    }

    ipAddress = ipData?.ip || '0.0.0.0';

    return { fingerPrintId, browserName, ipAddress }
}